import { render, staticRenderFns } from "./MemberName.vue?vue&type=template&id=27be8948&"
import script from "./MemberName.vue?vue&type=script&lang=js&"
export * from "./MemberName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports